var View = require('views/base/view');
var CustomContentView = View.extend({
  listen: {
    parentAddedToDOM: 'added'
  },
  initialize(options){
    this.template = require(`./templates/custom-${this.model.get('content_type')}`);
    View.prototype.initialize.apply(this, arguments);
  },
  added(){
    if(this.model.get('content_type') === 'modal'){
      this.modal = this.$('#custom-modal');
      this.modal.modal('show');
      this.done = true;
      this.modal.on('hidden.bs.modal', () => this.model.set('done', true));
    } else {
      this.done = true;
      this.model.set('done', true);
    }
  }
});

module.exports = CustomContentView;
